import * as ambassadorWixEventsV1Ticket from './events-v1-ticket-tickets.http.js';
import * as ambassadorWixEventsV1TicketTypes from './events-v1-ticket-tickets.types.js';
import * as ambassadorWixEventsV1TicketUniversalTypes from './events-v1-ticket-tickets.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listTickets(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsV1TicketUniversalTypes.ListTicketsRequest,
  ambassadorWixEventsV1TicketTypes.ListTicketsRequest,
  ambassadorWixEventsV1TicketUniversalTypes.ListTicketsResponse,
  ambassadorWixEventsV1TicketTypes.ListTicketsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Ticket.listTickets(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tickets',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTicket(): __PublicMethodMetaInfo<
  'GET',
  { ticketNumber: string },
  ambassadorWixEventsV1TicketUniversalTypes.GetTicketRequest,
  ambassadorWixEventsV1TicketTypes.GetTicketRequest,
  ambassadorWixEventsV1TicketUniversalTypes.GetTicketResponse,
  ambassadorWixEventsV1TicketTypes.GetTicketResponse
> {
  const payload = { ticketNumber: ':ticketNumber' } as any;

  const getRequestOptions = ambassadorWixEventsV1Ticket.getTicket(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tickets/{ticketNumber}',
    pathParams: { ticketNumber: 'ticketNumber' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function checkInTickets(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1TicketUniversalTypes.CheckInTicketRequest,
  ambassadorWixEventsV1TicketTypes.CheckInTicketRequest,
  ambassadorWixEventsV1TicketUniversalTypes.CheckInTicketResponse,
  ambassadorWixEventsV1TicketTypes.CheckInTicketResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Ticket.checkInTicket(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tickets/check-in',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteTicketCheckIns(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixEventsV1TicketUniversalTypes.DeleteTicketCheckInRequest,
  ambassadorWixEventsV1TicketTypes.DeleteTicketCheckInRequest,
  ambassadorWixEventsV1TicketUniversalTypes.DeleteTicketCheckInResponse,
  ambassadorWixEventsV1TicketTypes.DeleteTicketCheckInResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1Ticket.deleteTicketCheckIn(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/tickets/check-in',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTicket(): __PublicMethodMetaInfo<
  'PATCH',
  { ticketNumber: string },
  ambassadorWixEventsV1TicketUniversalTypes.UpdateTicketRequest,
  ambassadorWixEventsV1TicketTypes.UpdateTicketRequest,
  ambassadorWixEventsV1TicketUniversalTypes.UpdateTicketResponse,
  ambassadorWixEventsV1TicketTypes.UpdateTicketResponse
> {
  const payload = { ticketNumber: ':ticketNumber' } as any;

  const getRequestOptions = ambassadorWixEventsV1Ticket.updateTicket(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/tickets/{ticketNumber}',
    pathParams: { ticketNumber: 'ticketNumber' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateTickets(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEventsV1TicketUniversalTypes.BulkUpdateTicketsRequest,
  ambassadorWixEventsV1TicketTypes.BulkUpdateTicketsRequest,
  ambassadorWixEventsV1TicketUniversalTypes.BulkUpdateTicketsResponse,
  ambassadorWixEventsV1TicketTypes.BulkUpdateTicketsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1Ticket.bulkUpdateTickets(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/tickets',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TicketingTicket as TicketingTicketOriginal,
  Money as MoneyOriginal,
  CheckIn as CheckInOriginal,
  OrderStatus as OrderStatusOriginal,
  OrderStatusWithLiterals as OrderStatusWithLiteralsOriginal,
  GuestDetails as GuestDetailsOriginal,
  FormResponse as FormResponseOriginal,
  InputValue as InputValueOriginal,
  FormattedAddress as FormattedAddressOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  StandardDetails as StandardDetailsOriginal,
  FormSubmission as FormSubmissionOriginal,
  ChannelType as ChannelTypeOriginal,
  ChannelTypeWithLiterals as ChannelTypeWithLiteralsOriginal,
  TicketDetails as TicketDetailsOriginal,
  ListTicketsRequest as ListTicketsRequestOriginal,
  TicketFieldset as TicketFieldsetOriginal,
  TicketFieldsetWithLiterals as TicketFieldsetWithLiteralsOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  ListTicketsResponse as ListTicketsResponseOriginal,
  FacetCounts as FacetCountsOriginal,
  TicketFacets as TicketFacetsOriginal,
  TicketFacetCounts as TicketFacetCountsOriginal,
  Counts as CountsOriginal,
  GetTicketRequest as GetTicketRequestOriginal,
  GetTicketResponse as GetTicketResponseOriginal,
  CheckInTicketRequest as CheckInTicketRequestOriginal,
  CheckInTicketResponse as CheckInTicketResponseOriginal,
  OrderUpdated as OrderUpdatedOriginal,
  Ticket as TicketOriginal,
  OnlineConferencingLogin as OnlineConferencingLoginOriginal,
  DeleteTicketCheckInRequest as DeleteTicketCheckInRequestOriginal,
  DeleteTicketCheckInResponse as DeleteTicketCheckInResponseOriginal,
  UpdateTicketRequest as UpdateTicketRequestOriginal,
  GuestDetailsUpdate as GuestDetailsUpdateOriginal,
  UpdateTicketResponse as UpdateTicketResponseOriginal,
  BulkUpdateTicketsRequest as BulkUpdateTicketsRequestOriginal,
  BulkUpdateTicketsResponse as BulkUpdateTicketsResponseOriginal,
  GetDemoTicketRequest as GetDemoTicketRequestOriginal,
  GetDemoTicketResponse as GetDemoTicketResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './events-v1-ticket-tickets.types.js';
